module.exports = __webpack_public_path__ + "static/media/logo_redu.df43fec5.svg";